// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"02ad36a8","251":"4034123f","423":"113c74b5","842":"40fe5565","969":"8ff753f1"}[chunkId] + ".chunk.js";
};